import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, Output, EventEmitter } from '@angular/core';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { RoiService } from '../../service/roi.service';
import { Damage, DamageAnalysis } from '../../model/damage.model';
import { ReportService } from '../../service/report.service';
import { Report } from '../../model/report.model';
import { DamageService } from '../../service/damage.service';
import { Subscription } from 'rxjs';
import { TchekService } from '../../service/tchek.service';
import { ParametersService } from '../../service/parameters.service';
import { TchekImage } from '../../model/image';
const parse: typeof Parse = require('parse');

declare const $: any;

@Component({
  selector: 'app-roi-drawer',
  templateUrl: './roi-drawer.component.html',
  styleUrls: ['./roi-drawer.component.less'],
  animations: [
    trigger('openClose', [
      state('open', style({
        right: '0px'
      })),
      state('closed', style({
        right: '-28vw'
      })),
      transition('open => closed', [
        animate('350ms ease-out')
      ]),
      transition('closed => open', [
        animate('350ms ease-out')
      ]),
    ]),
  ]
})
export class RoiDrawerComponent implements OnInit, OnChanges {
  @ViewChild('drawerContent') drawerContent: ElementRef;
  @Input() tchekId: string;
  @Input() cameraName: string;
  @Input() currentImage: TchekImage;
  @Input() currentMode: string;
  @Output() itemClick = new EventEmitter<any>();
  @Output() damageSelected: EventEmitter<Damage>;
  @Output() damageDeleted: EventEmitter<Damage>;
  isOpen: boolean;
  autoRois: any;
  damages: any;
  report: Report;
  subscription: Subscription[];
  countNbr: number;
  canDetection = false
  constructor(
    private readonly _parametersService: ParametersService,
    private readonly _roiService: RoiService,
    private readonly _reportService: ReportService,
    private readonly _damageService: DamageService,
    private readonly _tchekService: TchekService
  ) {
    this.subscription = []
    this.isOpen = false;
    this.canDetection = this._parametersService.canDetection;
    this.damages = [];
    this.damageSelected = new EventEmitter<Damage>();
    this.damageDeleted = new EventEmitter<Damage>();

    this.subscription[0] = this._damageService.createroiObs.subscribe(data => {
      if (this.tchekId === data.tchekId) {
        this.countNbr++;
        if (this.countNbr > 0 && this.canDetection)
          this.isOpen = true;
      }
    })
    this.subscription[1] = this._damageService.deleteroiObs.subscribe(data => {
      if (this.tchekId === data.tchekPtr.id) {
        this.countNbr--;
        if (this.countNbr > 0 && this.canDetection)
          this.isOpen = true;
      }
    })
  }

  ngOnInit() {
    this._reportService.getByTchek(this.tchekId)
      .then(reports => {
        if (reports.length > 0)
          this.report = reports[0];
      });
  }

  ngOnChanges(changes: any) {
    if ((changes.tchekId && changes.tchekId.currentValue !== undefined)) {
      this._damageService.getByTchek(this.tchekId).then(dam => {
        this.countNbr = dam.length
        if (this.countNbr > 0)
          this.isOpen = true;
      })
    }
  }

  open() {
    this.isOpen = true;
    $('#da').css('height', 40 + 'px')

  }

  close() {
    this.isOpen = false;
  }

  toPicturePercent(numberPicture: number, totalPictures?: number): string {
    /* console.log('cam name ', this.cameraNumber, ' list ', this.listAnimation.array,
    ' this camera ', this.listAnimation.get(this.cameraNumber)); */
    if (totalPictures === undefined)
      console.warn('Both argument totalPictures and listCamera.totalPictures are undefined');
    /* console.log('numPic ', numberPicture, ' totalPic ', totalPictures, 'calcPercent ',
    ((numberPicture / totalPictures) * 100)); */
    return (Math.ceil((numberPicture / totalPictures) * 100)).toString();    // Minus 1 to fix last image being blank
  }

  handleListItemClick(event: any, damage: any) {
    $('.list-group-item').removeClass('active');
    // Setting bcg color
    $(event.target)
      .parentsUntil('div.content')
      .filter('.list-group-item')
      .addClass('active');
    if (this._roiService.getHighlightedDamage().id === damage.id) {
      this._roiService.setHighlightedDamage();
      $('.list-group-item').removeClass('active');
    } else
      this._roiService.setHighlightedDamage(damage);

    this.itemClick.emit(damage);
  }

  handleEditIntent(roi) {
    this._roiService.setRoiToEdit(roi);
    $('#editRoiModal').modal('show');
  }

  handleDamageDeleted(damage: Damage) {
    this.damageDeleted.emit(damage);
  }
  handleDamageSelected(damage: Damage) {
    this.damageSelected.emit(damage);
  }

  parts(): Array<string> {
    if (!this.damages)
      return [];
    else
      return Object.keys(this.damages);
  }
}



// WEBPACK FOOTER //
// ./src/app/element/roi-drawer/roi-drawer.component.ts